export type AppEnvironment = 'development' | 'staging' | 'production'

// Which deployment the running bundle belongs to.
//
// There is no environment variable for this: NEXT_PUBLIC_ENVIRONMENT exists in .env but is not
// listed in next.config.mjs `env`, so it never reaches the browser, and NODE_ENV is 'production'
// for staging and production builds alike. NEXT_PUBLIC_API_URL is whitelisted into the bundle and
// baked in at Docker build time, which makes the API host the only signal the client can trust.
//
// Rollbar reports environment from the same derivation (src/rollbar.ts), so the two stay in step.
export const getAppEnvironment = (): AppEnvironment => {
  if (process.env.NODE_ENV !== 'production') return 'development'

  return process.env.NEXT_PUBLIC_API_URL?.includes('staging.effektify.io')
    ? 'staging'
    : 'production'
}

export const isProductionEnvironment = (): boolean => getAppEnvironment() === 'production'

// Origin of the page, used as the BFF base URL: the browser calls the internal `/api` route
// handlers rather than the backend directly, and the API may live on a different subdomain.
// Empty during server rendering.
export const getSameOriginBaseURL = (): string => typeof window !== 'undefined'
  ? window.location.origin
  : ''
